// @ts-ignore
/* eslint-disable */
import request from "src/lib/axios";

/** 分页查询资产调拨记录 GET /api/v1/asset-transfers */
export async function AssetTransferControllerListV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.AssetTransferControllerListV1Params,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputAssetTransferDtoArray>(
    "/api/v1/asset-transfers",
    {
      method: "GET",
      params: {
        // pageSize has a default value: 10
        pageSize: "10",

        // logicOperator has a default value: and
        logicOperator: "and",

        // sortOrder has a default value: DESC
        sortOrder: "DESC",

        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 查询资产调拨记录详情 GET /api/v1/asset-transfers/${param0} */
export async function AssetTransferControllerDetailV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.AssetTransferControllerDetailV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputAssetTransferDto>(
    `/api/v1/asset-transfers/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}
